import listRaw from "./list_raw";

function listHelper(...args) {
  return listRaw(...args)
    .join(", ")
    .trim();
}

export default listHelper;
